var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"valid-input",class:{'error':_vm.error},on:{"change":function($event){return _vm.validation()}}},[_vm._t("default"),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],attrs:{"src":require("../assets/error.png"),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }